import React, { Suspense } from 'react';
const Spinner = React.lazy(() => import('../components/shared/Spinner'));

const LayerOverlay = props => {
  return (
    <div className='fallback minLayoutHeight'>
      <Suspense fallback={<h1>Loading...</h1>}>
        <Spinner />
      </Suspense>
    </div>
  );
};
export default LayerOverlay;
